import { render, staticRenderFns } from "./dialogTemplate.vue?vue&type=template&id=c1c0c51a&scoped=true&"
import script from "./dialogTemplate.vue?vue&type=script&lang=js&"
export * from "./dialogTemplate.vue?vue&type=script&lang=js&"
import style0 from "./dialogTemplate.vue?vue&type=style&index=0&id=c1c0c51a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1c0c51a",
  null
  
)

export default component.exports